module.exports = fox._r("fonts/tags-filter.eot?3lzqzp", __webpack_public_path__ + "_/_/_/root/fonts/38LfJPg.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/tags-filter.eot?3lzqzp
// module id = 442
// module chunks = 4